import {Component} from 'react'
import CryptoAES from 'crypto-js/aes';
import CryptoENC from 'crypto-js/enc-utf8';

class CookieService extends Component {
    static getVersion() {
        return 'status-2023-03-30';
    }

    static localStorageIsEnabled() {
        try {
          localStorage.getItem('local-storage-enabled');
        } 
        catch (e) {
            return false;
        }

        return true;
    }

    static getCookieSessionName(name) {
        let version = CookieService.getVersion();
        if (name.indexOf('user_') === 0) return version + name;

        // Si no tiene user_, indica que son configuraciones,
        // Y se guardan con el id del usuario para que obtenga sus preferencias
        // en este navegador...
        return version + CookieService.getPlainUserId() + name;
    }

    static getPlainUserId() {
        let version = CookieService.getVersion();
        let user_id = localStorage.getItem(version + "user_id");
        if (localStorage.getItem(version + "assisted_login_active") === '1') user_id = localStorage.getItem(version + "assisted_user_id");

        if (user_id == null) return user_id;
        user_id = CryptoAES.decrypt(user_id, window.env.GENERIC_FRONTEND_REACTJS_STATUS_ENCRYPT_KEY);
        user_id = user_id.toString(CryptoENC);

        return user_id;
    }

    static getCookie(name, default_value=null) {
        if (!localStorage) return null;

        name = CookieService.getCookieSessionName(name);

        let value = localStorage.getItem(name);
        if (value == null) return default_value;

        value = CryptoAES.decrypt(value, window.env.GENERIC_FRONTEND_REACTJS_STATUS_ENCRYPT_KEY);
        value = value.toString(CryptoENC);
        return value;
    }

    static setCookie(name, value, is_permanent) {
        if (!localStorage) return;

        name = CookieService.getCookieSessionName(name);

        value = CryptoAES.encrypt(value, window.env.GENERIC_FRONTEND_REACTJS_STATUS_ENCRYPT_KEY);
        localStorage.setItem(name, value);

        // Si no es permanente, se guarda una bandera indicando
        // que esta variable es de tipo session_storage...
        // Si es permanente, se elimina la bandera y queda con el funcionamiento por defecto.
        if (is_permanent) localStorage.removeItem("session_storage_" + name);
        else localStorage.setItem("session_storage_" + name, "default");
    }

    static removeCookie(name) {
        if (!localStorage) return;

        name = CookieService.getCookieSessionName(name);
        localStorage.removeItem(name);
        localStorage.removeItem("session_storage_" + name);
    }

    static clearSessionStorage() {
        if (!localStorage) return;

        let keys = Object.keys(localStorage);

        keys.forEach((key) => {
            if (localStorage.getItem("session_storage_" + key)) {
                localStorage.removeItem(key);
                localStorage.removeItem("session_storage_" + key);
            }
        });
    }

    static getLocale() {
        if (!localStorage) return 'es';
        let locale = CookieService.getCookie('user_locale', 'es');
        if (locale === '') return 'es';

        return locale;
    }

    static setLocale(locale) {
        if (!localStorage) return;
        CookieService.setCookie('user_locale', locale, true);
    }

    static isFirstLoad() {
        return (
            CookieService.getCookie('user_first_load') == null ||
            CookieService.getCookie('user_first_load') === '' ||
            CookieService.getCookie('user_first_load') === undefined
        );
    }

    static systemHasLoad() {
        CookieService.setCookie('user_first_load', 'true');
    }

    static getSmallAndTemporalCookie(name, default_value=null) {
        name = CookieService.getVersion() + name;
        let value = sessionStorage.getItem(name);
        if (!value) return default_value;

        return value;
    }

    static setSmallAndTemporalCookie(name, value) {
        name = CookieService.getVersion() + name;
        sessionStorage.setItem(name, value);
    }    
}

export default CookieService;
